const BASE_PATH = '/v1/trader/profile';

const PATHS = {
  getPersonalDetails: (): string => `${BASE_PATH}/personal-details`,
  changePassword: (): string => `${BASE_PATH}/password`,
};

export default PATHS;
